import React from 'react';
import h from 'react-hyperscript';
import {Input, Button} from '@material-ui/core';
import './ShareReportLink.scss';

export default function ShareLink() {
  const [buttonText, setButtonText] = React.useState('Copy link');

  const copyLink = () => {
    const linkText = document.getElementById('report-link');
    linkText.select();
    linkText.setSelectionRange(0, 99999); /* For mobile devices*/
    document.execCommand('copy');
    setButtonText('Copied to clipboard');
  };

  return (
    h('div', {className: 'share-link__container'}, [
      h(Input, {
        id: 'report-link',
        value: window.location.origin + '/guest/',
        className: 'share-link__input',
        variant: 'filled',
      }),
      h(Button, {
        color: 'primary',
        onClick: copyLink,
        variant: 'contained',
        size: 'medium',
        color: 'primary',
        className: 'share-link__button',
      }, [buttonText]),
      h('p', {className: 'share-link__learn-more'},
          'Share this link directly with any email address ' +
          'you\'ve added to the report. A user will not be ' +
          'notified of their access otherwise.',
      ),
    ])
  );
}
